// import { motion } from 'framer-motion'
// import { Menu, X, ChevronDown } from 'lucide-react'
// import { useState, useEffect } from 'react'
// import { Link } from 'react-router-dom'
// import logo from '../assets/al-konda-logo--647x500.png'
// import '../styles/glassmorphism.css'

// const Header = () => {
//   const [isOpen, setIsOpen] = useState(false)
//   const [scrolled, setScrolled] = useState(false)
//   const [servicesOpen, setServicesOpen] = useState(false)

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50)
//     }
//     window.addEventListener('scroll', handleScroll)
//     return () => window.removeEventListener('scroll', handleScroll)
//   }, [])

//   const services = [
//     { name: 'Construction', href: '/services/construction' },
//     { name: 'Power Generation', href: '/services/power-generation' },
//     { name: 'Environmental', href: '/services/environmental' },
//     { name: 'Oil & Fuel Supply', href: '/services/oil-fuel-supply' },
//     { name: 'Logistics', href: '/services/logistics' },
//     { name: 'General Trading', href: '/services/general-trading' },
//     { name: 'Recycling', href: '/services/recycling' }
//   ]

//   const navItems = [
//     { name: 'About', href: '/about' },
//     { name: 'Contact', href: '#contact' }
//   ]

//   return (
//     <>
//       <motion.header 
//         initial={{ y: -30, opacity: 0 }}
//         animate={{ y: 0, opacity: 1 }}
//         transition={{ duration: 0.8, ease: "easeOut" }}
//         className="fixed w-full z-[100] transition-all duration-300"
//       >
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
//           <div className={`glassmorphism-container rounded-2xl lg:rounded-[24px] p-4 lg:p-6 transition-all duration-300 ${
//             scrolled ? 'shadow-[0_8px_32px_rgba(0,0,0,0.15)]' : 'shadow-[0_8px_32px_rgba(0,0,0,0.1)]'
//           }`}>
//             <div className="flex items-center justify-between">
//               <Link to="/" className="flex items-center gap-3 group">
//                 <div className="glassmorphism-card w-12 h-12 rounded-xl overflow-hidden p-2 group-hover:scale-105 transition-transform duration-300">
//                   <img 
//                     src={logo}
//                     alt="AL-KONDA Logo" 
//                     className="w-full h-full object-contain"
//                   />
//                 </div>
//                 <div className="font-semibold text-lg tracking-wide text-white group-hover:text-white/80 transition-colors duration-300">
//                   AL-KONDA
//                 </div>
//               </Link>

//               <nav className="hidden md:flex items-center gap-6 lg:gap-8">
//                 {/* Services Dropdown */}
//                 <div 
//                   className="relative"
//                   onMouseEnter={() => setServicesOpen(true)}
//                   onMouseLeave={() => setServicesOpen(false)}
//                 >
//                   <button className="text-sm font-medium text-white/90 hover:text-white transition-colors duration-300 relative group flex items-center gap-1">
//                     Services
//                     <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${servicesOpen ? 'rotate-180' : ''}`} />
//                     <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white transition-all duration-300 group-hover:w-full"></span>
//                   </button>

//                   {servicesOpen && (
//                     <motion.div
//                       initial={{ opacity: 0, y: 10 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       exit={{ opacity: 0, y: 10 }}
//                       className="absolute top-full left-0 mt-2 w-48 glassmorphism rounded-xl p-2 shadow-xl"
//                     >
//                       {services.map((service) => (
//                         <Link
//                           key={service.name}
//                           to={service.href}
//                           className="block px-3 py-2 text-sm text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-all duration-200"
//                         >
//                           {service.name}
//                         </Link>
//                       ))}
//                     </motion.div>
//                   )}
//                 </div>

//                 {navItems.map((item) => (
//                   <a
//                     key={item.name}
//                     href={item.href}
//                     className="text-sm font-medium text-white/90 hover:text-white transition-colors duration-300 relative group"
//                   >
//                     {item.name}
//                     <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white transition-all duration-300 group-hover:w-full"></span>
//                   </a>
//                 ))}
//               </nav>

//               <button 
//                 onClick={() => setIsOpen(!isOpen)}
//                 className="md:hidden glassmorphism p-2 rounded-lg text-white transition-all duration-300 hover:bg-white/20"
//               >
//                 {isOpen ? <X size={20} /> : <Menu size={20} />}
//               </button>
//             </div>
//           </div>
//         </div>
//       </motion.header>

//       {/* Mobile Menu */}
//       {isOpen && (
//         <motion.div
//           initial={{ opacity: 0, y: -10 }}
//           animate={{ opacity: 1, y: 0 }}
//           exit={{ opacity: 0, y: -10 }}
//           className="fixed top-24 left-4 right-4 z-[90] md:hidden"
//         >
//           <div className="glassmorphism-card rounded-xl p-6 space-y-4">
//             {/* Mobile Services */}
//             <div>
//               <div className="text-white/90 font-medium py-2">Services</div>
//               <div className="ml-4 space-y-2">
//                 {services.map((service) => (
//                   <Link
//                     key={service.name}
//                     to={service.href}
//                     onClick={() => setIsOpen(false)}
//                     className="block text-white/70 hover:text-white py-1 transition-colors duration-300 text-sm"
//                   >
//                     {service.name}
//                   </Link>
//                 ))}
//               </div>
//             </div>

//             {navItems.map((item) => (
//               <a
//                 key={item.name}
//                 href={item.href}
//                 onClick={() => setIsOpen(false)}
//                 className="block text-white/90 hover:text-white font-medium py-2 transition-colors duration-300"
//               >
//                 {item.name}
//               </a>
//             ))}
//           </div>
//         </motion.div>
//       )}
//     </>
//   )
// }

// export default Header


import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, ChevronDown } from 'lucide-react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import LanguageSwitcher from './LanguageSwitcher';
import logo from '../assets/al-konda-logo-optimized.webp';
import '../styles/glassmorphism.css'; // Assuming this provides the base styles



const Header = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false); // Mobile menu open/close
  const [scrolled, setScrolled] = useState(false); // Scroll detection
  const [servicesOpen, setServicesOpen] = useState(false); // Desktop services dropdown
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false); // Mobile services dropdown
  const [logoLoaded, setLogoLoaded] = useState(false);

  const services = [
    { name: t('header.servicesList.construction'), href: '/services/construction' },
    { name: t('header.servicesList.powerGeneration'), href: '/services/power-generation' },
    { name: t('header.servicesList.environmental'), href: '/services/environmental' },
    { name: t('header.servicesList.oilFuelSupply'), href: '/services/oil-fuel-supply' },
    { name: t('header.servicesList.logistics'), href: '/services/logistics' },
    { name: t('header.servicesList.generalTrading'), href: '/services/general-trading' },
    { name: t('header.servicesList.recycling'), href: '/services/recycling' }
  ];

  const navItems = [
    { name: t('header.about'), href: '/about' },
    { name: t('header.contact'), href: '/contact' }
  ];

  // Effect to handle scroll event
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Variant for desktop dropdown menu
  const menuVariants = {
    hidden: { opacity: 0, y: 10, transition: { duration: 0.2 } },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
  };

  // Variant for mobile menu (main and service list)
  const mobileMenuVariants = {
    hidden: { opacity: 0, height: 0, transition: { duration: 0.3 } },
    visible: { opacity: 1, height: "auto", transition: { duration: 0.4 } },
  };

  return (
    <>
      <motion.header
        initial={{ y: -50, opacity: 0 }} // Start higher up
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.7, ease: "easeOut" }} // Slightly faster transition
        className="fixed w-full z-[100] transition-all duration-300 backdrop-blur-sm" // Add backdrop-blur for depth
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 lg:py-4"> {/* Adjusted vertical padding */}
          <div className={`
            glassmorphism-container 
            rounded-2xl lg:rounded-[24px] 
            p-3 lg:p-5 
            transition-all duration-300 
            border border-white/10 ${scrolled ? 'shadow-2xl' : 'shadow-xl'}
          `}>
            <div className="flex items-center justify-between">
              {/* Logo and Text */}
              <Link to="/" className="flex items-center gap-3 group" onClick={() => setIsOpen(false)}>
                <div className="bg-white w-14 h-14 lg:w-16 lg:h-16 rounded-2xl overflow-hidden p-1.5 group-hover:scale-[1.05] transition-transform duration-300 shadow-lg shadow-black/20">
                  <img
                    src="/al-konda-logo--647x500.png"
                    alt="AL-KONDA Logo"
                    fetchPriority="high"
                    className="w-full h-full object-contain"
                    width="80"
                    height="62"
                  />
                </div>
                <div className="font-extrabold text-xl tracking-wider text-white transition-colors duration-300">
                  AL-KONDA
                </div>
              </Link>

              {/* Desktop Navigation */}
              <nav className="hidden md:flex items-center gap-7 lg:gap-10">
                <LanguageSwitcher />
                {/* Services Dropdown */}
                <div
                  className="relative h-full flex items-center"
                  onMouseEnter={() => setServicesOpen(true)}
                  onMouseLeave={() => setServicesOpen(false)}
                >
                  <button className="text-sm font-semibold text-white/90 hover:text-white transition-colors duration-300 relative group flex items-center gap-1 py-2">
                    {t('header.services')}
                    <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${servicesOpen ? 'rotate-180' : ''}`} />
                    <span className="absolute -bottom-0 left-0 w-0 h-0.5 bg-white/70 transition-all duration-300 group-hover:w-full"></span>
                  </button>

                  <AnimatePresence>
                    {servicesOpen && (
                      <motion.div
                        initial="hidden"
                        animate="visible"
                        exit="hidden"
                        variants={menuVariants}
                        className="absolute top-full right-1/2 translate-x-1/2 mt-4 min-w-[200px] bg-white/5 backdrop-blur-xl rounded-xl p-2 shadow-2xl border border-white/10 origin-top"
                      >
                        {services.map((service) => (
                          <Link
                            key={service.name}
                            to={service.href}
                            onClick={() => setServicesOpen(false)}
                            className="block px-4 py-2 text-sm font-medium text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-all duration-200"
                          >
                            {service.name}
                          </Link>
                        ))}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>

                {navItems.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className="text-sm font-semibold text-white/90 hover:text-white transition-colors duration-300 relative group py-2"
                  >
                    {item.name}
                    <span className="absolute -bottom-0 left-0 w-0 h-0.5 bg-white/70 transition-all duration-300 group-hover:w-full"></span>
                  </Link>
                ))}
              </nav>

              {/* Mobile Menu Button */}
              <button
                onClick={() => { setIsOpen(!isOpen); setMobileServicesOpen(false); }}
                className="md:hidden glassmorphism p-3 rounded-xl text-white transition-all duration-300 hover:bg-white/20 border border-white/10"
                aria-label={isOpen ? "Close navigation menu" : "Open navigation menu"}
                aria-expanded={isOpen}
              >
                {isOpen ? <X size={20} /> : <Menu size={20} />}
              </button>
            </div>
          </div>
        </div>
      </motion.header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className="fixed top-[100px] left-4 right-4 z-[90] md:hidden"
          >
            <div className="glassmorphism-card rounded-2xl p-6 space-y-4 border border-white/10 shadow-2xl backdrop-blur-md">

              {/* Mobile Services Dropdown Toggle */}
              <div>
                <button
                  onClick={() => setMobileServicesOpen(!mobileServicesOpen)}
                  className="w-full flex items-center justify-between text-white font-bold py-2 hover:text-white/80 transition-colors duration-300"
                >
                  {t('header.services')}
                  <ChevronDown className={`w-5 h-5 transition-transform duration-300 ${mobileServicesOpen ? 'rotate-180' : ''}`} />
                </button>

                <AnimatePresence>
                  {mobileServicesOpen && (
                    <motion.div
                      initial="hidden"
                      animate="visible"
                      exit="hidden"
                      variants={mobileMenuVariants}
                      className="ml-4 pt-2 space-y-2 overflow-hidden"
                    >
                      {services.map((service) => (
                        <Link
                          key={service.name}
                          to={service.href}
                          onClick={() => setIsOpen(false)}
                          className="block text-white/70 hover:text-white py-1 transition-colors duration-300 text-base font-medium border-l border-white/20 pl-4 hover:border-white"
                        >
                          {service.name}
                        </Link>
                      ))}
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>

              {/* Language Switcher for Mobile */}
              <div className="pt-2 border-t border-white/20">
                <LanguageSwitcher isMobile={true} />
              </div>

              {/* Other Mobile Nav Items */}
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setIsOpen(false)}
                  className="block text-white font-bold py-2 transition-colors duration-300 hover:text-white/80"
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

export default Header;